import { render, staticRenderFns } from "./ActivitySettingsSwitch.vue?vue&type=template&id=37299391"
import script from "./ActivitySettingsSwitch.vue?vue&type=script&lang=ts"
export * from "./ActivitySettingsSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports